module.exports = __webpack_public_path__ + "media/images/three-dots-black-7926c721f4a473a349a35a69a23b8aac.svg";